var _style, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenFlash2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#56AE4D;}\n\t.st2{fill:#1E1F22;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "backgroundrect",
    className: "st0",
    width: 512,
    height: 512
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "svg_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M194.8,500c-1.3,0-2.6-0.1-3.9-0.3c-5.8-1-11-4.3-14.4-9.2c-3.4-4.9-4.7-10.8-3.7-16.7L200,324H96 c-7.7,0-14.7-4.4-18-11.4s-2.3-15.2,2.5-21.2L299.6,20.6c4.2-5.4,10.7-8.6,17.6-8.6l0,0c1,0,1.9,0.1,2.8,0.2 c5.9,0.7,11.3,3.7,14.9,8.5c3.7,4.7,5.3,10.6,4.6,16.6c0,0.4-0.1,0.8-0.2,1.1L312,188h104c7.7,0,14.7,4.4,18,11.4 s2.3,15.2-2.5,21.2L212.4,491.5C208.2,496.8,201.7,500,194.8,500L194.8,500z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M317.2,32c0.1,0,0.2,0,0.3,0c1.3,0.2,2.3,1.4,2.1,2.7L288,208h128L196.7,479c-0.4,0.6-1.1,0.9-1.9,1l0,0 c-0.1,0-0.3,0-0.4,0c-1.3-0.2-2.1-1.5-1.9-2.7L224,304H96L315.3,33C315.7,32.4,316.4,32,317.2,32L317.2,32 M317.2-8L317.2-8 c-0.1,0-0.1,0-0.2,0c-12.9,0.1-25.2,6.1-33.1,16.1l-219,270.7c-9.7,12-11.6,28.5-5,42.4C66.5,335.1,80.6,344,96,344h80.1 l-22.9,126.1c0,0.1,0,0.1,0,0.2c-4.1,23,11.4,45,34.4,49.1c2.4,0.4,4.9,0.6,7.4,0.6c12.9,0,25.2-6,33.2-16l219.1-270.8 c9.7-12,11.6-28.5,5-42.4S431.6,168,416.2,168h-80l23-126.1c0.1-0.8,0.3-1.5,0.4-2.3c1.4-11.3-1.7-22.4-8.7-31.3s-17-14.6-28.3-16 C320.7-7.9,319-8,317.2-8L317.2-8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenFlash2);
export default __webpack_public_path__ + "static/media/green-flash2.eb9f744d1c434b5ce206da09df1cefd2.svg";
export { ForwardRef as ReactComponent };